/**
 * Similar to alt-utils/lib/ImmutableUtil in that it maintains an immutable state
 * but functions the way setState normally does by merging the
 * existing state with the new state
 */
export default function immutableStore(StoreModel, overrides) {
  StoreModel.config = Object.assign(
    {
      setState(currentState, nextState) {
        this.state = currentState.merge(nextState);
        return this.state;
      },

      getState(currentState) {
        return currentState;
      },
    },
    overrides
  );

  return StoreModel;
}
